import { HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CfgService } from '../../cfg/cfg.service';
import { AccessManagerResource } from './accessManager.models';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class AccessManagerCfg {
  public gestorEndpoint: string;
  public cacheTTL: number;
  public endpoint: string;
  public defaults: AccessManagerResource[];
}

@Injectable({
  providedIn: 'root'
})
export class AccessManagerCfgService extends CfgService<AccessManagerCfg> {
  json: any = {
    gestorEndpoint: "%{GestorApiUrl}",
    cacheTTL: "25000",
    endpoint: "%{GestorApiUrl}/users/permissions?resourceId={0}",
    defaults: [
      {
        ResourceId: 1111,
        ResourceName: "/dashboard",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: true
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: true
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: true
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: true
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: true
          }
        ]
      },
      {
        ResourceId: 189,
        ResourceName: "Launcher Page",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: true
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: true
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: true
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: true
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: true
          }
        ]
      },
      {
        ResourceId: 197,
        ResourceName: "fh_icon_fbitalent_offers",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: true
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: true
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: true
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: true
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: true
          }
        ]
      },
      {
        ResourceId: 199,
        ResourceName: "fh_icon_fbifront_clients",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: true
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: true
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: true
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: true
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: true
          }
        ]
      },
      {
        ResourceId: 3946,
        ResourceName: "fh_icon_fbifront_clients_entities",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: true
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: true
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: true
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: true
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: true
          }
        ]
      },
      {
        ResourceId: 200,
        ResourceName: "fh_icon_reports",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: true
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: true
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: true
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: true
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: true
          }
        ]
      },
      {
        ResourceId: 205,
        ResourceName: "fh_icon_fbitalent_buckets",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: true
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: true
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: true
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: true
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: true
          }
        ]
      },
      {
        ResourceId: 206,
        ResourceName: "fh_icon_relevate_reference",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: true
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: true
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: true
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: true
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: true
          }
        ]
      },
      {
        ResourceId: 233,
        ResourceName: "fh_icon_relevate_adn",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: true
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: true
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: true
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: true
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: true
          }
        ]
      },
      {
        ResourceId: 499,
        ResourceName: "fh_icon_fbifront_workers",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: true
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: true
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: true
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: true
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: true
          }
        ]
      },
      {
        ResourceId: 533,
        ResourceName: "fh_icon_fbiback_gesfico",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: true
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: true
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: true
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: true
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: true
          }
        ]
      },
      {
        ResourceId: 2602,
        ResourceName: "fh_icon_fbiback_payroll",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: true
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: true
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: true
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: true
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: true
          }
        ]
      },
      {
        ResourceId: -3,
        ResourceName: "fh_icon_fbitalent_eureka",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: true
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: true
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: true
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: true
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: true
          }
        ]
      },
      {
        ResourceId: 1111,
        ResourceName: "/dashboard",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: false
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: false
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: false
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: false
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: false
          }
        ]
      },
      {
        ResourceId: 1724,
        ResourceName: "fh_icon_candidateprocess",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: false
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: false
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: false
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: false
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: false
          }
        ]
      },
      {
        ResourceId: 1894,
        ResourceName: "fh_icon_salarycheck",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: false
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: false
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: false
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: false
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: false
          }
        ]
      },
      {
        ResourceId: 1956,
        ResourceName: "fh_icon_fbiback_invoice",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: false
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: false
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: false
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: false
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: false
          }
        ]
      },
      {
        ResourceId: 1954,
        ResourceName: "fh_icon_fbirpo_joborders",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: false
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: false
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: false
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: false
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: false
          }
        ]
      },
      {
        ResourceId: 1955,
        ResourceName: "fh_icon_fbirpo_planner",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: false
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: false
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: false
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: false
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: false
          }
        ]
      },
      {
        ResourceId: 2608,
        ResourceName: "fh_icon_fbiprofessionals",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: false
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: false
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: false
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: false
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: false
          }
        ]
      },
      {
        ResourceId: 2665,
        ResourceName: "fh_icon_relevate_reference_professionals",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: false
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: false
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: false
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: false
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: false
          }
        ]
      },
      {
        ResourceId: 2989,
        ResourceName: "fh_icon_truefit_offering",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: false
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: false
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: false
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: false
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: false
          }
        ]
      },
      {
        ResourceId: 3212,
        ResourceName: "fh_icon_fbifront_timesheets",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: false
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: false
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: false
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: false
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: false
          }
        ]
      },
      {
        ResourceId: 3671,
        ResourceName: "fh_icon_fbifront_platforms",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: false
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: false
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: false
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: false
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: false
          }
        ]
      },
      {
        ResourceId: 3726,
        ResourceName: "fh_icon_fbifront_bbva",
        ResourceActions: [
          {
            ActionTypeId: 1,
            Description: "Acceso",
            AllowChk: false
          },
          {
            ActionTypeId: 2,
            Description: "Visibilidad",
            AllowChk: false
          },
          {
            ActionTypeId: 3,
            Description: "Habilitación",
            AllowChk: false
          },
          {
            ActionTypeId: 4,
            Description: "Ejecución",
            AllowChk: false
          },
          {
            ActionTypeId: 9,
            Description: "Obligatoriedad",
            AllowChk: false
          }
        ]
      }
    ]
  };

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/accessManager.cfg.json`;
  }

  /**
   * Carga las url en el json
   */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
